import { render, staticRenderFns } from "./chat_page.vue?vue&type=template&id=311e9af6&scoped=true"
import script from "./chat_page.vue?vue&type=script&lang=ts"
export * from "./chat_page.vue?vue&type=script&lang=ts"
import style0 from "./chat_page.vue?vue&type=style&index=0&id=311e9af6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311e9af6",
  null
  
)

export default component.exports